export default __webpack_public_path__ + "static/zycie-cb6cd9817501f51d001f7ba7e7a40ea9.jpeg";